import { NgModule } from '@angular/core';
import { ChartModule } from "primeng/chart";
import { TreeModule } from "primeng/tree";
import { DialogService, DynamicDialogModule } from "primeng/dynamicdialog";

import { TableModule } from "primeng/table";
import { ContextMenuModule } from "primeng/contextmenu";
import { FileUploadModule } from "primeng/fileupload";
import { RadioButtonModule } from "primeng/radiobutton";
import { ListboxModule } from "primeng/listbox";
import { PaginatorModule } from "primeng/paginator";
import { PickListModule } from "primeng/picklist";
import { DialogModule } from "primeng/dialog";
import { AccordionModule } from "primeng/accordion";
import { CalendarModule } from "primeng/calendar";
import { TooltipModule } from 'primeng/tooltip';
import { CarouselModule } from "primeng/carousel";
import { MessageModule } from "primeng/message";
import { TreeTableModule } from "primeng/treetable";
import { OrderListModule } from "primeng/orderlist";
import { SharedModule } from "primeng/api";
import { TabViewModule } from "primeng/tabview";
import { InputTextModule } from "primeng/inputtext";
import { SplitButtonModule } from "primeng/splitbutton";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { InputSwitchModule } from 'primeng/inputswitch';
import { SpeedDialModule } from "primeng/speeddial";
import { SidebarModule } from "primeng/sidebar";
import { MultiSelectModule } from "primeng/multiselect";
import { MenuModule } from "primeng/menu";
import { PanelModule } from "primeng/panel";

@NgModule({
    declarations: [],
    imports: [
        TreeModule,
        DynamicDialogModule,
        ContextMenuModule,
        FileUploadModule,
        RadioButtonModule,
        ListboxModule,
        PaginatorModule,
        PickListModule,
        SharedModule,
        TableModule,
        DialogModule,
        AccordionModule,
        CalendarModule,
        ContextMenuModule,
        ListboxModule,
        PickListModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
        CarouselModule,
        MessageModule,
        OrderListModule,
        TabViewModule,
        InputTextModule,
        InputSwitchModule,
        SplitButtonModule,
        OverlayPanelModule,
        SpeedDialModule,
        SidebarModule,
        MultiSelectModule,
        MenuModule,
        PanelModule
    ],
    exports: [
        ChartModule,
        DynamicDialogModule,
        ContextMenuModule,
        FileUploadModule,
        RadioButtonModule,
        ListboxModule,
        PaginatorModule,
        PickListModule,
        SharedModule,
        TableModule,
        DialogModule,
        AccordionModule,
        CalendarModule,
        ContextMenuModule,
        ListboxModule,
        PickListModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
        CarouselModule,
        MessageModule,
        TabViewModule,
        InputTextModule,
        SplitButtonModule,
        OverlayPanelModule,
        OrderListModule,
        InputSwitchModule,
        SpeedDialModule,
        SidebarModule,
        MultiSelectModule,
        MenuModule,
        PanelModule
    ],
    providers: [
        DialogService
    ]
})
export class PrimeNGLibraryModule {
}
